import { render, staticRenderFns } from "./BloomRegistration.vue?vue&type=template&id=07d90ace&scoped=true&"
import script from "./BloomRegistration.vue?vue&type=script&lang=js&"
export * from "./BloomRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BloomRegistration.vue?vue&type=style&index=0&id=07d90ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d90ace",
  null
  
)

export default component.exports